import { render, staticRenderFns } from "./CardPage.vue?vue&type=template&id=792ccfb6&scoped=true&"
import script from "./CardPage.vue?vue&type=script&lang=js&"
export * from "./CardPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792ccfb6",
  null
  
)

export default component.exports